import Image from 'next/image';
import Header from 'widgets/header';
import * as Styles from './styles';

interface IProps {
    onClick: any;
}

const items = [
    'I/We hereby confirm that the information provided herein is accurate, correct and complete and that the documents submitted along with this such are genuine.',
    'I/We hereby confirm that I have not concealed or distorted any information submitted.',
    'I/We undertake to inform in writing of any changes to the information already provided and to update the information whenever requested to do so.',
    'I/We undertake to conduct the business in a lawful manner and shall always abide by the applicable laws.',
    'I/We hereby declare that, in the event any information is required or needs to be shared with any third party in accordance with applicable law, I/we explicitly agree to full compliance without my/our additional consent.',
    'I/We understand that I/We might have to submit relevant information in future as and when desired and I/We agree to execute / sign relevant document to enable the transaction',
    'I/We understand and agree that this declaration is final and irrevocable, and that it is not subject to cancellation or amendments.',
];

function LegalDocumentTnc({ onClick }: IProps) {
    const onClickDownload = () => {
        window.open(
            'https://acko-public.s3.ap-south-1.amazonaws.com/pos/oppo/dealer-tnc.pdf'
        );
    };

    return (
        <Styles.Wrapper>
            <Header />
            <Styles.Headaer>
                <Styles.BackArrow>
                    <Image
                        src={'/icons/backArrow.svg'}
                        alt={''}
                        width={20}
                        height={20}
                        onClick={onClick}
                        style={{ cursor: 'pointer' }}
                    />
                </Styles.BackArrow>
                <Styles.Download>
                    <Image
                        src={'/icons/download.svg'}
                        alt={''}
                        width={20}
                        height={20}
                        onClick={onClickDownload}
                        style={{ cursor: 'pointer' }}
                    />
                </Styles.Download>
            </Styles.Headaer>
            <ul>
                {items.map((item, i) => (
                    <li
                        style={{ margin: '10px 0', lineHeight: '20px' }}
                        key={i}
                    >
                        {item}
                    </li>
                ))}
            </ul>
        </Styles.Wrapper>
    );
}

export default LegalDocumentTnc;
